import React, { FC, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { FloatButton } from 'antd';

// Импорты для новых компонентов (нужно будет создать эти файлы)
import { HeroSection } from '../screen/HeroSection'; // Пример
import { RefsProps } from '../types/landing.interface'; // Возможно, RefsProps нужно будет адаптировать
import { SlickStyle } from '../../../ui/App/slick';
import { AudienceSection } from '../screen/AudienceSection';
import { TransferSection } from '../screen/TransferSection';
import { AssistantSection } from '../screen/AssistantSection';
import { ContactsSection } from '../screen/ContactsSection';
import { BenefitsSection } from '../screen/BenefitsSection';
// import { Feedback } from '../../AppLayout/components/Navbar/components/Feedback'; // Убираем, если не используется в новом дизайне

// Оставляем GlobalStyle пустым или для других глобальных правил (например, шрифты)
const GlobalStyle = createGlobalStyle`
  /* Сюда можно добавить глобальные стили, например, для шрифтов, если нужно */

`;

export const Content: FC<RefsProps> = ({
    // Обновите refs, если они все еще нужны для навигации по новым секциям
    telegramRef,
    chatBotRef,
    crmRef, // Переименовать или удалить
    // ...другие refs
}) => {
    return (
        <Fragment>
            <GlobalStyle />
            <SlickStyle /> {/* Оставляем, если карусель будет использоваться */}
            <StyledContainer>
                {/* Заменяем старые компоненты на новые, соответствующие дизайну */}
                {/* <Heading refProp={headingRef} /> */}
                <HeroSection /> {/* Используем новый компонент */}
                <AudienceSection />
                <TransferSection refProp={telegramRef} />
                <AssistantSection refProp={chatBotRef} />
                <ContactsSection refProp={crmRef} />
                <BenefitsSection />
                {/* <TelegramAdvantages /> */}
                {/* <TelegramMiniApps refProp={telegramRef} /> */}
                {/* <EcomOpportunities refProp={ecomRef} /> */}
                {/* <PathToPurchase /> */}
                {/* <OurClients /> */}
                {/* <IndividualConditions refProp={individualConditionsRef} /> */}
                {/* <AboutUs refProp={aboutUsRef} /> */}
                {/* <SpodialShowcase /> */}
            </StyledContainer>
            <FloatButton.BackTop />
        </Fragment>
    );
};

// Стили для основного контейнера, можно добавить фон здесь, если он общий для всех секций
const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 1160px; // Судя по дизайну, контент уже
    height: auto;
    padding: 0 20px;
    margin: 0 auto;
    z-index: 1;

    /* Убираем медиа-запрос, если ширина всегда 1160px max */
    /* @media (max-width: 992px) {
        padding: 0 20px;
    } */
`;
